<template>
  <div class="cbaas-upload">
    <el-upload
      ref="upload"
      drag
      class="upload-input"
      :action="url"
      :on-change="handleChange"
      :show-file-list="false"
      :auto-upload="false"
    >
      <div class="select-file">
        <i class="el-icon-upload icon-upload"></i>
        <span class="tips">点击上传/拖拽到此区域</span>
      </div>
    </el-upload>
    <div v-show="!$utils.isEmpty(currentFile)" class="file-list">
      <div class="fileName">{{ currentName }}</div>
      <div class="delete" @click="handleRemove">
        <i class="el-icon-delete"></i>
      </div>
    </div>
    <div v-show="showTips" class="bi-tian">请选择文件</div>
  </div>
</template>

<script>
export default {
  name: 'UploadFile',
  props: {
    title: {
      type: String,
      default: ''
    },
    showValidate: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    fileExt: {
      type: String,
      default: '.wasm|.abi|.bin|.sol|.7z|.crt|.key|.zip|.yml|'
    }
  },
  data() {
    return {
      url: '',
      currentFile: {},
      currentName: '',
      showTips: false
    }
  },
  methods: {
    uploadBeforeUploadHandle(file) {
      let extName = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
      let AllUpExt = this.fileExt || '.wasm|.abi|.bin|.sol|.7z|.crt|.key|.zip|.yml|'
      const isLt2M = file.size / 1024 / 1024 < 50
      if (AllUpExt.indexOf(extName + '|') === -1) {
        this.$message.error('文件格式不正确')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过50MB!')
        return false
      }
      return true
    },
    handleChange(file) {
      let validate = this.uploadBeforeUploadHandle(file)
      if (validate) {
        this.currentFile = file
        this.currentName = file.name
        if (this.showTips) {
          this.showTips = false
        }
        this.$emit('uploadSuccess')
      } else {
        this.clear()
        this.$emit('uploadFailed')
      }
    },
    handleRemove() {
      this.currentFile = {}
      this.currentName = ''
      this.$emit('uploadRemove')
    },
    clear() {
      this.currentFile = {}
      this.currentName = ''
      this.showTips = false
    },
    getFileRaw() {
      if (this.$utils.isEmpty(this.currentFile)) {
        if (this.showValidate) {
          this.showTips = true
        }
        return false
      } else {
        return this.currentFile
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.cbaas-upload {
  @include adaptation(());
  /deep/ {
    .el-upload-dragger {
      width: 100%;
      height: var(--base-size-36);
      border: 0;
    }
    .el-upload-dragger .el-icon-upload {
      margin: 0;
      line-height: var(--base-size-36);
    }
    .el-upload {
      width: 100%;
    }
  }
  .upload-input {
    width: 100%;
    height: var(--base-size-36);
  }
  .select-file {
    width: 100%;
    height: var(--base-size-36);
    background: var(--base-background-color-lighter);
    display: flex;
    align-items: center;
    // justify-content: center;
    padding: 0 var(--base-size-16);
    .icon-upload {
      font-size: var(--base-font-size-huge);
      color: var(--base-color-text-primary);
    }
    .tips {
      font-size: var(--base-font-size-medium);
      color: var(--base-color-text-primary);
      margin-left: var(--base-size-8);
      margin-top: var(--base-size-2);
    }
  }
  .bi-tian {
    color: var(--base-color-danger);
    height: var(--base-size-20);
    line-height: var(--base-size-20);
  }
  .file-list {
    height: var(--base-size-36);
    line-height: var(--base-size-36);
    background: var(--base-background-color-lighter);
    border-radius: var(--base-border-radius);
    padding: 0 var(--base-size-8);
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: var(--base-size-8);
    .fileName {
      width: calc(100% - var(--base-size-24));
      font-size: var(--base-font-size-common);
      color: var(--base-color-text-regular);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding-right: var(--base-size-12);
    }
    .delete {
      width: var(--base-size-24);
      height: var(--base-size-24);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      i {
        font-size: var(--base-font-size-large);
        color: var(--base-color-danger);
      }
    }
  }
}
</style>
